/**
 * qualificationApi.js
 * -------------------
 * API client for Qualification Master (Qualifications) using createMasterApiClient.
 * Connects directly to FastAPI backend /qualification/ endpoints.
 * 100% conforming to module_implementation_standards.md.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const qualificationClient = createMasterApiClient('qualification');

export const listQualifications = (params) => qualificationClient.list(params);
export const getQualificationDetail = (id) => qualificationClient.getById(id);
export const createQualification = (data) => qualificationClient.create(data);
export const updateQualification = (id, data) => qualificationClient.update(id, data);
export const archiveQualification = (id) => qualificationClient.archive(id);
export const deleteQualification = (id) => qualificationClient.remove(id);
export const getQualificationOptions = () => qualificationClient.getDropdownOptions();
